exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[disabled]{cursor:not-allowed!important}.slide-fade-enter-active,.slide-fade-leave-active{transition:.24s cubic-bezier(.25,1,.5,1)}.slide-fade-enter-from,.slide-fade-leave-to{transform:translateX(10px);opacity:0}", ""]);

// exports
